import { render } from "./BusBupinCheckInfo.vue?vue&type=template&id=5c4423f9&scoped=true"
import script from "./BusBupinCheckInfo.vue?vue&type=script&lang=js"
export * from "./BusBupinCheckInfo.vue?vue&type=script&lang=js"

import "./BusBupinCheckInfo.vue?vue&type=style&index=0&id=5c4423f9&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4423f9"]])

export default __exports__